import React, { createContext, useContext, useState } from 'react';
import axios, { CancelTokenSource } from 'axios';
import {
    buscarClientesModuloClientes,
    enviarNovoClienteERP,
    buscarRamoAtividade,
    buscarSegmento,
    infoCliente,
    consultarCNPJ
} from '../modules/clientes/apis/serviceCliente';
import { Toast } from '../themes/components/Toast';
//importing context
import { removeItemSessionStorage, useLocalStorage } from './LocalStorage';
import {
    PropChildren,
    Cliente,
    InterfaceNovoCliente,
    InfoCliente,
    validacaoCNPJ
} from '../modules/clientes/interfaces';
const PedidosContext = createContext({} as PropsContextProvier);

type PropsContextProvier = {
    buscarClientes: (filter: string, doc: string, history: any) => void;
    loadingBuscaClientes: boolean;
    clientesBusca: Cliente[];
    cadastrarNovoCliente: (cliente: InterfaceNovoCliente, history: any) => Promise<any>
    consultarRamoAtividade: (find: string, history: any) => Promise<any>
    consultarSegmento: (find: string, history: any) => Promise<any>
    consultarInfoCliente: (cliente: string, history: any) => Promise<InfoCliente>
    consultaCNPJ: (cnpj: string, uf: string, history: any) => Promise<validacaoCNPJ>
}

export default function ClientesProvider({ children }: PropChildren) {
    const { getFromSessionStorage } = useLocalStorage();
    const [clientesBusca, setClientesBusca] = useState<Cliente[]>([]);
    const [loadingBuscaClientes, setLoadingBuscaClientes] = useState<boolean>(false);

    //Tokens de requisições
    const [tokenRequestMDCliente, setTokenRequestMDCliente] = useState<any>();

    function buscarClientes(filter: string, doc: string, history: any) {
        setLoadingBuscaClientes(true);
        filtrarClientes(filter, doc, history);
    }

    async function filtrarClientes(find: string, doc: string, history: any) {
        const CancelToken = axios.CancelToken;
        let cancelSource: CancelTokenSource | null = null;

        if (tokenRequestMDCliente !== undefined) {
            tokenRequestMDCliente.cancel();
        }

        cancelSource = CancelToken.source();
        setTokenRequestMDCliente(cancelSource);

        new Promise<Cliente[]>(() => {
            buscarClientesModuloClientes(find, doc, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"), cancelSource?.token)
                .then(res => {
                    setClientesBusca(res instanceof Array ? res : [res]);
                    setTokenRequestMDCliente(undefined);
                    setLoadingBuscaClientes(false);
                })
                .catch(err => {
                    if (axios.isCancel(err.error)) {
                        //console.log("Requisição cancelada!");
                    } else {
                        if (err.error.message !== undefined) {
                            if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                                redirectTo(history, '/login', { from: history.location.pathname });
                            }else if(err.error.message.includes("Network Error")){
                                Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            }
                        } else {
                            Toast("error", "Falha ao consultar Cliente");
                        }
                        setClientesBusca([]);
                        setLoadingBuscaClientes(false);
                    }
                })
        })
    }

    async function consultaCNPJ(cnpj: string, uf: string, history: any) {
        return new Promise<validacaoCNPJ>((resolve, reject) => {
            consultarCNPJ(cnpj, uf, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    if (err.error !== undefined && err.error.message !== undefined) {
                        if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                            reject("Sessão Expirada! Realize o Login novamente");
                        }else if(err.error.message.includes("Network Error")){
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        }
                    } else if(err.errors !== undefined && err.errors[0].message !== undefined) {
                        reject({ error: {message: err.errors[0].message} });
                    }
                    reject(err);
                })
        })
    }
    

    async function cadastrarNovoCliente(cliente: InterfaceNovoCliente, history: any) {
        return new Promise<any>((resolve, reject) => {
            enviarNovoClienteERP(JSON.stringify(cliente), getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    if (err.error !== undefined && err.error.message !== undefined) {
                        if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                            reject("Sessão Expirada! Realize o Login novamente");
                        }else if(err.error.message.includes("Network Error")){
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        }
                    } else if(err.errors !== undefined && err.errors[0].message !== undefined) {
                        reject({ error: {message: err.errors[0].message} });
                    }else {
                        Toast("error", "Falha ao cadastrar Cliente");
                    }
                    reject(err);
                })
        })
    }

    async function consultarInfoCliente(cliente: string, history: any) {
        return new Promise<InfoCliente>((resolve, reject) => {
            infoCliente(cliente, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    if (err.error.message !== undefined) {
                        if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                            reject("Sessão Expirada! Realize o Login novamente");
                        }else if(err.error.message.includes("Network Error")){
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        }
                    } else {
                        Toast("error", "Falha ao consultar Cliente");
                    }
                    reject(err);
                })
        })
    }

    async function consultarRamoAtividade(find: string, history: any) {
        return new Promise<Cliente[]>((resolve, reject) => {
            buscarRamoAtividade(find, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    if (err.error.message !== undefined) {
                        if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        }else if(err.error.message.includes("Network Error")){
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        }
                    } else {
                        Toast("error", "Falha ao consultar Cliente");
                    }
                    reject(err);
                })
        })
    }
    async function consultarSegmento(find: string, history: any) {
        return new Promise<Cliente[]>((resolve, reject) => {
            buscarSegmento(find, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    if (err.error.message !== undefined) {
                        if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        }else if(err.error.message.includes("Network Error")){
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        }
                    } else {
                        Toast("error", "Falha ao consultar Cliente");
                    }
                    reject(err);
                })
        })
    }


    function redirectTo(history: any, pathname: string, state: { from: string }) {
        if(pathname === "/login"){
            removeItemSessionStorage("logid");
        }
        history.push({
            pathname: process.env.PUBLIC_URL + pathname,
            state: state
        })
    }

    return (
        <PedidosContext.Provider
            value={{
                loadingBuscaClientes,
                buscarClientes,
                clientesBusca,
                cadastrarNovoCliente,
                consultarRamoAtividade,
                consultarSegmento,
                consultarInfoCliente,
                consultaCNPJ
            }}>
            {children}
        </PedidosContext.Provider>
    )
}

export function useClientes() {
    const context = useContext(PedidosContext);
    if (!context) throw new Error("usePedidos must be used within an PedidosProvider");
    const {
        buscarClientes,
        loadingBuscaClientes,
        clientesBusca,
        cadastrarNovoCliente,
        consultarRamoAtividade,
        consultarSegmento,
        consultarInfoCliente,
        consultaCNPJ
    } = context;
    return ({
        buscarClientes,
        loadingBuscaClientes,
        clientesBusca,
        cadastrarNovoCliente,
        consultarRamoAtividade,
        consultarSegmento,
        consultarInfoCliente,
        consultaCNPJ
    });
}